import BarChartVert from './bar-chart-vert.svg';
import BarChartHoriz from './bar-chart-horiz.svg';
import Calendar from './calendar.svg';
import Dashboard from './dashboard.svg';
import Rearrange from './rearrange.svg';
import ViewDetail from './view-detail.svg';
import Zoom from './zoom.svg';
import Dimensionality from './dimensionality.svg';
import Note from './note.svg';
import Trend from './trend.svg';
import SingleNumber from './single-number.svg';
import PageFlow from './page-flow.svg';
import Heatmap from './heatmap.svg';

export default {
  'dashboards/bar-chart-vert': BarChartVert,
  'dashboards/bar-chart-horiz': BarChartHoriz,
  'dashboards/calendar': Calendar,
  'dashboards/dashboard': Dashboard,
  'dashboards/rearrange': Rearrange,
  'dashboards/view-detail': ViewDetail,
  'dashboards/zoom': Zoom,
  'dashboards/dimensionality': Dimensionality,
  'dashboards/single-number': SingleNumber,
  'dashboards/note': Note,
  'dashboards/trend': Trend,
  'dashboards/page-flow': PageFlow,
  'dashboards/heatmap': Heatmap,
};
